import React from 'react'
import { PlaybookCard } from '../PlaybookCard'
import { PlaybookCardsGridProps } from './types'

export const PlaybookCardsGrid: React.FC<PlaybookCardsGridProps> = ({
  playbooks,
  cardVariant = 'default',
  onPlaybookAction,
}) => (
  <div className="grid grid-cols-1 items-stretch gap-3 sm:grid-cols-2 sm:gap-4 md:gap-6 lg:grid-cols-3 xl:grid-cols-4">
    {playbooks.map((playbook) => (
      <PlaybookCard
        key={playbook._id}
        playbook={playbook}
        variant={cardVariant}
        onPlaybookAction={(action) => {
          onPlaybookAction?.(action, playbook)
        }}
      />
    ))}
  </div>
)
